import { Response } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { Tuple } from '../../entities';
import { PreferencesViewModel, CurrencyViewModel, LanguageViewModel, PreferenceTaskListVM, EnablePreferenceTasksVM, UserPreferenceDashboardFleetColumnVM, UCComponentInspectionOrderVM, GridColumn, UserGridColumnPreferenceUpdateDto } from './models/preferences.model';
import { catchError } from 'rxjs/operators';
import { GenericIdName } from '../GET_NEW_UI/setup-implement/setup-implement.model';
import { throwError } from 'rxjs';
import { ReportConfigurationViewModel } from '../GET_NEW_UI/dashboard/dashboard.model';

@Injectable()
export class PreferencesService {
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = {
    headers: this.headers
  };

  constructor(private _http: HttpClient) { }

  public getGeneralTabPreferences(): Observable<PreferencesViewModel> {
    return this._http.get<PreferencesViewModel>("api/preferences/GetUserPreferences").pipe(catchError(this.handleError));
  }

  public getUsername(): Observable<any> {
    return this._http.get("api/preferences/GetUsername").pipe(catchError(this.handleError));
  }

  public GetEmail(): Observable<any> {
    return this._http.get("api/preferences/GetEmail").pipe(catchError(this.handleError));
  }

  public getAllLanguages(): Observable<LanguageViewModel[]> {
    return this._http.get<LanguageViewModel[]>("api/preferences/GetAllLanguages").pipe(catchError(this.handleError));
  }

  
  public getAllCurrencies(): Observable<CurrencyViewModel[]> {
    return this._http.get<CurrencyViewModel[]>("api/preferences/GetAllCurrencies").pipe(catchError(this.handleError));
  }
  public getAllFormCategories(): Observable<GenericIdName[]> {
    return this._http.get<GenericIdName[]>("api/preferences/GetAllCurrencies").pipe(catchError(this.handleError));
  }
  public getInspectionsDueEmails(): Observable<any> {
      return this._http.get("api/preferences/GetInspectionsDueEmails").pipe(catchError(this.handleError));
  }

  public getDailyInspectionsDueEmails(): Observable<any> {
    return this._http.get("api/preferences/GetDailyInspectionsDueEmails").pipe(catchError(this.handleError));
}

public getShowMaintenanceInsp(): Observable<any> {
  return this._http.get("api/preferences/GetShowMaintenanceInsp").pipe(catchError(this.handleError));
}

  public getIncludeMaintenanceLastInspect(): Observable<any> {
    return this._http.get("api/preferences/GetIncludeMaintenanceLastInspect").pipe(catchError(this.handleError));
  }

  public updateLanguage(languageId: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateLanguage", languageId, this.options).pipe(catchError(this.handleError));
  }

  public updateUom(uom: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('uom', uom)
    };
    return this._http.get<Tuple>("api/preferences/UpdateUom", options).pipe(catchError(this.handleError));
  }
  public updateUod(uod: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('uod', uod)
    };
    return this._http.get<Tuple>("api/preferences/UpdateUod", options).pipe(catchError(this.handleError));
  }

  public updateEmail(email: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('email', email)
    };
    return this._http.get<Tuple>("api/preferences/UpdateEmail", options).pipe(catchError(this.handleError));
  }

  public updateFullName(name: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('name', name)
    };
    return this._http.get<Tuple>("api/preferences/UpdateFullName", options).pipe(catchError(this.handleError));
  }

  public updatePhoneNumber(number: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('number', number)
    };
    return this._http.get<Tuple>("api/preferences/UpdatePhoneNumber", options).pipe(catchError(this.handleError));
  }

  public updateStreetAddress(address: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('address', address)
    };
    return this._http.get<Tuple>("api/preferences/UpdateStreetAddress", options).pipe(catchError(this.handleError));
  }

  public updateSuburb(suburb: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('suburb', suburb)
    };
    return this._http.get<Tuple>("api/preferences/UpdateSuburb", options).pipe(catchError(this.handleError));
  }

  public updatePostCode(code: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('code', code)
    };
    return this._http.get<Tuple>("api/preferences/UpdatePostCode", options).pipe(catchError(this.handleError));
  }

  public updateState(state: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('state', state)
    };
    return this._http.get<Tuple>("api/preferences/UpdateState", options).pipe(catchError(this.handleError));
  }

  public updateCountry(country: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('country', country)
    };
    return this._http.get<Tuple>("api/preferences/UpdateCountry", options).pipe(catchError(this.handleError));
  }

  public updateCurrency(currencyId: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateCurrency", currencyId, this.options).pipe(catchError(this.handleError));
  }

  public updateDefaultFormCategory(FormCatId: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateUserDefaultFormCategory", FormCatId, this.options).pipe(catchError(this.handleError));
  }

  public updateDefaultUCsetupType(SetupId: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateUserDefaultUCSetupType", SetupId, this.options).pipe(catchError(this.handleError));
  }

  public updateEqCondition(ConditionType: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateEqCondition", ConditionType, this.options).pipe(catchError(this.handleError));
  }

  public UpdateEqConditionPage(ConditionType: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateEqConditionPage", ConditionType, this.options).pipe(catchError(this.handleError));
  }

  


  public updateUsername(username: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('username', username)
    };
    return this._http.get<Tuple>("api/preferences/UpdateUsername", options).pipe(catchError(this.handleError));
  }

  public updatePassword(password: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('password', password)
    };
    return this._http.get<Tuple>("api/preferences/UpdatePassword", options).pipe(catchError(this.handleError));
  }

  public updateInspectionsDueEmails(inspectionsDueEmails: boolean): Observable<Tuple> {
      let options = {
          params: new HttpParams().set('inspectionsDueEmails', inspectionsDueEmails.toString())
      };
      return this._http.get<Tuple>("api/preferences/UpdateInspectionsDueEmails", options).pipe(catchError(this.handleError));
  }

    public UpdateDashboardAlerts(inspectionsDueEmails: boolean): Observable<Tuple> {
      let options = {
          params: new HttpParams().set('dashBoardAlert', inspectionsDueEmails.toString())
      };
      return this._http.get<Tuple>("api/preferences/UpdateDashboardAlerts", options).pipe(catchError(this.handleError));
  }

  public updateDailyInspectionsDueEmails(inspectionsDueEmails: boolean): Observable<Tuple> {
    let options = {
        params: new HttpParams().set('inspectionsDueEmails', inspectionsDueEmails.toString())
    };
    return this._http.get<Tuple>("api/preferences/updateDailyInspectionsDueEmails", options).pipe(catchError(this.handleError));
}

public updateShowMaintenanceInsp(ShowMaintenanceInsp: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('ShowMaintenanceInsp', ShowMaintenanceInsp.toString())
  };
  return this._http.get<Tuple>("api/preferences/updateShowMaintenanceInsp", options).pipe(catchError(this.handleError));
  }

  public updateSIncludeMaintenanceLastInspect(IncludeMaintenanceLastInspect: boolean): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('IncludeMaintenanceLastInspect', IncludeMaintenanceLastInspect.toString())
    };
    return this._http.get<Tuple>("api/preferences/UpdateIncludeMaintenanceLastInspect", options).pipe(catchError(this.handleError));
  }


public UpdateEnablePIPEmails(PIPEmaill: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('PIPEmaill', PIPEmaill.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnablePIPEmails", options).pipe(catchError(this.handleError));
}

public UpdateEnableDFIEmails(DFIEmaill: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('DFIEmaill', DFIEmaill.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnableDFIEmails", options).pipe(catchError(this.handleError));
}

public UpdateEnableQLDEmails(QLDEmail: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('QLDEmail', QLDEmail.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnableQLDEmails", options).pipe(catchError(this.handleError));
}

public UpdateEnableNSWEmails(NSWEmail: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('NSWEmail', NSWEmail.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnableNSWEmails", options).pipe(catchError(this.handleError));
}

public UpdateEnableWAEmails(WAEmail: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('WAEmail', WAEmail.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnableWAEmails", options).pipe(catchError(this.handleError));
}

public GetPIPEmailsEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetPIPEmailsEnableStatus").pipe(catchError(this.handleError));
}

public GetDFIEmailsEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetDFIEmailsEnableStatus").pipe(catchError(this.handleError));
}

public GetQLDEmailsEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetQLDEmailsEnableStatus").pipe(catchError(this.handleError));
}

public GetNSWEmailsEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetNSWEmailsEnableStatus").pipe(catchError(this.handleError));
}

public GetDashBoardAlertEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetDashBoardAlertEnableStatus").pipe(catchError(this.handleError));
}

public GetWAEmailsEnableStatus(): Observable<any> {
  return this._http.get("api/preferences/GetWAEmailsEnableStatus").pipe(catchError(this.handleError));
}

public UpdateEnableReplaceExistingTab(EnableExistingTab: boolean): Observable<Tuple> {
  let options = {
      params: new HttpParams().set('EnableExistingTab', EnableExistingTab.toString())
  };
  return this._http.get<Tuple>("api/preferences/UpdateEnableReplaceExistingTab", options).pipe(catchError(this.handleError));
}

public GetReplaceExistingTabStatus(): Observable<any> {
  return this._http.get("api/preferences/GetReplaceExistingTabStatus").pipe(catchError(this.handleError));
}

public getTaskPreferenceForUser(): Observable<PreferenceTaskListVM[]> {
  return this._http.get<PreferenceTaskListVM[]>("api/preferences/getTaskPreferenceForUser").pipe(catchError(this.handleError));
}

public updatepreference(): Observable<Tuple> {
  return this._http.get<Tuple>("api/preferences/updatepreference",  this.options).pipe(catchError(this.handleError));
}

public updatePreferenceforLoggedUser(taskIDs: number[]): Observable<Tuple> {
  return this._http.post<Tuple>("api/preferences/updatePreferenceforLoggedUser", taskIDs, this.options).pipe(catchError(this.handleError));
}
public updateDashboradFleetPreferenceforLoggedUser(taskIDs: number[]): Observable<Tuple> {
  return this._http.post<Tuple>("api/preferences/updateDashboradFleetPreferenceforLoggedUser", taskIDs, this.options).pipe(catchError(this.handleError));
}

public getPreferenceTaskListForLoggedUser(): Observable<EnablePreferenceTasksVM> {
  return this._http.get<EnablePreferenceTasksVM>("api/preferences/getPreferenceTaskListForLoggedUser").pipe(catchError(this.handleError));
}

public getPreferenceDashboardFleetColumnListForLoggedUser(): Observable<UserPreferenceDashboardFleetColumnVM> {
  return this._http.get<UserPreferenceDashboardFleetColumnVM>("api/preferences/getPreferenceDashboardFleetColumnListForLoggedUser").pipe(catchError(this.handleError));
}

public getDashboardFleetPreferenceForUser(): Observable<PreferenceTaskListVM[]> {
  return this._http.get<PreferenceTaskListVM[]>("api/preferences/getDashboardFleetPreferenceForUser").pipe(catchError(this.handleError));
}

public GetGridColumnsWithUserPreferenceAsync(screenCode: string): Observable<GridColumn[]> {
  const options = {
      params: new HttpParams().set('screenCode', screenCode.toString())
    };
  return this._http.get<GridColumn[]>("api/preferences/GetDisplayColumnOptionsByUser",options).pipe(catchError(this.handleError));
}

public UpdateGridColumnPreference(selectedOptions: number[]): Observable<boolean> {
    return this._http.post<boolean>("api/preferences/UpdateGridColumnPreference", selectedOptions, this.options).pipe(catchError(this.handleError));
  }
  // private handleError(error: Response) {
  //   console.error(error);
  //   return Observable.throw(JSON.stringify(error) || 'Server error');
  // }
  
private handleError(error: HttpErrorResponse) {
  console.error(error);
  return throwError(JSON.stringify(error) || 'Server error');
}

  public UpdateUCComponentInspectionOrderOption(UCCompInspectOrderOptionId: number): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateUCComponentInspectionOrderOption", UCCompInspectOrderOptionId, this.options).pipe(catchError(this.handleError));
  }
  public UpdateUCMultipleMeasurements(UCMultipleMeasurements: boolean): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateUCMultipleMeasurements", UCMultipleMeasurements, this.options).pipe(catchError(this.handleError));
  }
  public UpdateUCForecastWornToday(UCForecastWornToday: boolean): Observable<Tuple> {
    return this._http.post<Tuple>("api/preferences/UpdateUCForecastWorn", UCForecastWornToday, this.options).pipe(catchError(this.handleError));
  }
  public getComponentInspectionOrderList(): Observable<UCComponentInspectionOrderVM[]> {
    return this._http.get<UCComponentInspectionOrderVM[]>("api/preferences/getComponentInspectionOrderList").pipe(catchError(this.handleError));
  }
  public recalculateSortOrder(Id: number, sortOrder: number, incrementOrder: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('Id', Id.toString()).set('SortOrder', sortOrder.toString()).set('IncrementOrder', incrementOrder.toString())
    };
    return this._http.get('Api/preferences/RecalculateComponentInspectionSortOrder', options)
      .pipe(catchError(this.handleError));
  }
  public setInspectInRevrseFlag(id: number, flag: boolean):
    Observable<any> {
    const options = {
      params: new HttpParams().set('Id', id.toString()).set('Flag', flag.toString())
    };
    return this._http.get('Api/preferences/SetInspectInRevrse', options)
      .pipe(catchError(this.handleError));
  }
  public setMeasurementCounts(id: number, measurementCount: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('Id', id.toString()).set('MeasurementCount', measurementCount.toString())
    };
    return this._http.get('Api/preferences/SetMeasurementCounts', options)
      .pipe(catchError(this.handleError));
  }
  public FleetReportPdf(ReportParameter: any): Observable<any> {
    return this._http.post<any>("api/Dashboard/GetFleetReportPdf", ReportParameter, this.options).pipe(catchError(this.handleError));
  }

  public GetAlertsAsync(alertTypeId:number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('AlertTypeId', alertTypeId.toString())
    };
    return this._http.get('Api/Alerts/GetAlertsAsync', options)
      .pipe(catchError(this.handleError));
  }

  updateAlertStatus(alertId: number, isEnabled: boolean) {
  return this._http.post(
    `Api/Alerts/UpdateAlertStatus`,
    { 'AlertId': alertId, 'IsEnabled': isEnabled }
  );
}
  updateAlertEmailStatus(alertId: number, isEnabled: boolean) {
  return this._http.post(
    `Api/Alerts/UpdateAlertEmailEnabled`,
    { 'AlertId': alertId, 'IsEnabled': isEnabled }
  );
}
updateWornPercentage(data: any) {
  return this._http.post('/api/Alerts/UpdateWornPercentage', data);
}

getAlertFleetReportConfiguration(): Observable<ReportConfigurationViewModel[]> {
    return this._http.get<ReportConfigurationViewModel[]>('Api/Alerts/GetAlertFleetReportConfiguration').pipe(catchError(this.handleError));
  }

public submitFleetAlertReport(body: ReportConfigurationViewModel[]): Observable<any> {
    return this._http.post('Api/Alerts/submitFleetAlertReport', body).pipe(catchError(this.handleError));
  }
}
